export class SMSDATA {

    ID: number;
    VQuad_Timestamp: Date;
    Start_Timestamp: Date;
    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;
    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;
    Start_GPS_Position: string;
    Start_GPS_Lat: number;
    Start_GPS_Long: number;
    Net_Speed_Test: string;
    Battery_Level: number;
    RSSI: number;
    Network_Type: string;
    TN_Number: string;
    Target_Server: string;
    TestStatus: string;

    Total_Msg_Send: number;
    Total_Msg_Failed: number;
    Min_Time_SMS: number;
    Avg_Time_SMS: number;
    Max_Time_SMS: number;
    Total_Msg_Recieved: number;
    Total_RecieveSMS_Expected: number;
    Time_of_FirstSMS: string;
    Time_of_LastSMS: string;

    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;

    constructor() {
    this.ID = 0;
    this.VQuad_Timestamp = new Date();
    this.Start_Timestamp = new Date();
    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";
    this.GPS_Position = "";
    this.GPS_Lat = 0;
    this.GPS_Long = 0;
    this.Start_GPS_Position = "";
    this.Start_GPS_Lat = 0;
    this.Start_GPS_Long = 0;
    this.Net_Speed_Test = "";
    this.Battery_Level = 0;
    this.RSSI = 0;
    this.Network_Type = "";
    this.TN_Number = "";
    this.Target_Server = "";
    this.TestStatus = "";
  
    this.Total_Msg_Send = 0;
    this.Total_Msg_Failed = 0;
    this.Min_Time_SMS = 0;
    this.Avg_Time_SMS = 0;
    this.Max_Time_SMS = 0;
    this.Total_Msg_Recieved = 0;
    this.Total_RecieveSMS_Expected = 0;
    this.Time_of_FirstSMS = "";
    this.Time_of_LastSMS = "";
   
    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";

    }
}
